<template>
  <b-modal
    :id="id"
    :title="`Create New File for ${majorVersion}.x.x`"
    hide-footer
    @shown="$refs.newFileName.focus()">
    <b-form
      lazy
      @submit="onSubmit"
      @reset="onReset">
      <b-form-group
        id="newFileName"
        label="File Name:"
        label-for="newFileName">
        <b-form-input
          id="newFileName"
          ref="newFileName"
          v-model="fileName"
          type="text"
          placeholder="name.json"
          required />
      </b-form-group>
      <div
        slot="modal-footer"
        class="mt-2 w-100">
        <b-btn
          type="submit"
          variant="primary"
          class="ml-2 float-right">
          Create
        </b-btn>
        <b-btn
          type="reset"
          variant="secondary"
          class="float-right">
          Cancel
        </b-btn>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
  import { File } from '@/services/api'

  export default {
    name: "NewFileModal",
    props: {
      id: {
        type: String,
        required: true,
      },
      configs: {
        type: Array,
        required: true,
      },
      platformId: {
        type: Number,
        required: false,
        default: -1,
      },
      majorId: {
        type: Number,
        required: false,
        default: -1,
      },
    },
    data() {
      return {
        fileName: null,
        majorVersion: null,
      }
    },
    watch: {
      majorId(newVal) {
        const majorConfig = this.configs.find(c => c.id === newVal)
        if (majorConfig) {
          this.majorVersion = majorConfig.version
        }
      },
    },
    methods: {
      onReset() {
        this.fileName = null
        this.$root.$emit('bv::hide::modal', this.id)
      },
      async onSubmit(evt) {
        evt.preventDefault()
        await File.create(this.majorId, this.fileName)
        this.$router.push({ path: '/', query: { platformId: this.platformId.toString(), majorId: this.majorId.toString() } })
        this.$emit('refresh-files')
        this.onReset()
      },
    },
  }
</script>

<style scoped>

</style>